export default __webpack_public_path__ + "static/murata-1e71c71722ce6bc07e27386167699760.jpg";